<template>
  <div>Fluxo de Crédito do Cliente</div>
</template>
<script>
export default {

}
</script>
